export const emailIsValid = (email: string) => {
  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)
}

export const isValidEmailDomain = (email: string) => {
  const emailParts = email.split("@")

  if (emailParts.length !== 2) {
    return false
  }

  const emailDomainParts = emailParts[1].split(".")

  // drop .ru/.com/.ua/.etc
  emailDomainParts.pop()

  const emailDomain = emailDomainParts.join(".")

  return !["temp"].includes(emailDomain)
}
